import { useAuthWrapper } from '@weareopenr/authkit';
import { FEATURE_FLAGS } from 'src/constants';
import StandaloneOptionGroupOverrides from './StandaloneOptionGroupOverrides';
import ProductOptionGroupOverrides from './ProductOptionGroupOverrides';

const PriceSchemeOptionGroupOverridesTab = ({ priceSchemeId }: { priceSchemeId: string }) => {
  const { featureFlags } = useAuthWrapper();

  if (featureFlags.includes(FEATURE_FLAGS.INDEPENDENT_OPTION_GROUPS)) {
    return <StandaloneOptionGroupOverrides priceSchemeId={priceSchemeId} />;
  }

  return <ProductOptionGroupOverrides priceSchemeId={priceSchemeId} />;
};

export default PriceSchemeOptionGroupOverridesTab;
